// extracted by mini-css-extract-plugin
export var box = "_7w-1";
export var checked = "_7w-2";
export var descriptionSpacer = "_7w-9";
export var disabled = "_7w-3";
export var icon = "_7w-6";
export var input = "_7w-0";
export var labelSpacer = "_7w-8";
export var medium = "_7w-5";
export var small = "_7w-4";
export var text = "_7w-7";